import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.00098 11.5C9.82846 11.5002 10.5 12.1715 10.5 12.999V13.001C10.5 13.8285 9.82846 14.4998 9.00098 14.5H8.99902C8.1714 14.5 7.5 13.8286 7.5 13.001V12.999C7.5 12.1714 8.1714 11.5 8.99902 11.5H9.00098Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.001 11.5C15.8285 11.5002 16.5 12.1715 16.5 12.999V13.001C16.5 13.8285 15.8285 14.4998 15.001 14.5H14.999C14.1714 14.5 13.5 13.8286 13.5 13.001V12.999C13.5 12.1714 14.1714 11.5 14.999 11.5H15.001Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0C13.1046 0 14 0.89543 14 2C14 2.73976 13.5971 3.3835 13 3.72949V5C17.2834 5 20.8654 7.99185 21.7754 12H22C23.1046 12 24 12.8954 24 14C24 15.1046 23.1046 16 22 16H21.7754C20.8654 20.0082 17.2834 23 13 23H11C6.71661 23 3.13458 20.0082 2.22461 16H2C0.89543 16 0 15.1046 0 14C0 12.8954 0.89543 12 2 12H2.22461C3.13458 7.99185 6.71661 5 11 5V3.72949C10.4029 3.3835 10 2.73976 10 2C10 0.89543 10.8954 0 12 0ZM12 8.25C9.12907 8.25001 7.31702 9.20711 6.29492 10.6611C5.31668 12.053 5.20708 13.7023 5.27344 14.8223C5.36452 16.3596 6.71295 17.25 8.00879 17.25H15.9912C17.287 17.2499 18.6345 16.3596 18.7256 14.8223C18.7919 13.7022 18.6825 12.053 17.7041 10.6611C16.682 9.20719 14.8707 8.25007 12 8.25Z"}}]};

const Robot2Filled = Vue.extend<IconProps>({
  name: 'Robot2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'robot-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Robot2Filled;
